import React from "react";
import { Card, Box, Skeleton, Stack } from "@mui/material";
import { colors, borderRadiusPx, customShadows } from "../../../../../theme";

export const TermsHeroSkeleton = () => (
  <Card
    sx={{
      p: { xs: 3, sm: 4 },
      borderRadius: borderRadiusPx.xl,
      backgroundColor: colors.dashboard.cardBg,
      border: `1px solid ${colors.dashboard.cardBorder}`,
      boxShadow: customShadows.cardFlat,
      mb: 4,
    }}
  >
    <Stack spacing={2.5}>
      <Stack direction="row" spacing={1.5} alignItems="center">
        <Skeleton variant="rounded" width={44} height={44} sx={{ borderRadius: borderRadiusPx.lg }} />
        <Box sx={{ width: "65%" }}>
          <Skeleton variant="text" width="60%" height={38} />
          <Skeleton variant="text" width="40%" height={18} />
        </Box>
      </Stack>
      <Skeleton variant="text" width="90%" height={22} />
      <Skeleton variant="rounded" width="100%" height={42} sx={{ borderRadius: borderRadiusPx.xl, maxWidth: 600 }} />
      <Stack direction="row" spacing={1.5}>
        <Skeleton variant="rounded" width={160} height={36} sx={{ borderRadius: borderRadiusPx.md }} />
        <Skeleton variant="rounded" width={160} height={36} sx={{ borderRadius: borderRadiusPx.md }} />
        <Skeleton variant="rounded" width={160} height={36} sx={{ borderRadius: borderRadiusPx.md }} />
      </Stack>
    </Stack>
  </Card>
);

export const TermsContentSkeleton = () => (
  <Card
    sx={{
      p: { xs: 3, sm: 4.5 },
      borderRadius: borderRadiusPx.xl,
      backgroundColor: colors.dashboard.cardBg,
      border: `1px solid ${colors.dashboard.cardBorder}`,
      boxShadow: customShadows.cardFlat,
      mb: 4,
    }}
  >
    <Stack spacing={4}>
      {[1, 2, 3, 4].map((i) => (
        <Box key={i}>
          <Stack direction="row" spacing={1.5} alignItems="center" sx={{ mb: 2 }}>
            <Skeleton variant="rounded" width={32} height={32} sx={{ borderRadius: borderRadiusPx.sm }} />
            <Skeleton variant="text" width="40%" height={28} />
          </Stack>
          <Stack spacing={1.5} sx={{ pl: { xs: 0, sm: 5.5 } }}>
            <Skeleton variant="rounded" width="100%" height={60} sx={{ borderRadius: borderRadiusPx.lg }} />
            <Skeleton variant="rounded" width="100%" height={60} sx={{ borderRadius: borderRadiusPx.lg }} />
          </Stack>
        </Box>
      ))}
    </Stack>
  </Card>
);

export default TermsHeroSkeleton;
